module.exports = __webpack_public_path__ + "img/undraw_People_search_re_5rre.f6633ca2.svg";